import { LOGICAL_PARENT, LayerElement } from '../../UNSAFE_Layer/Layer';

const getLogicalParent = (node: Node) => {
  if (node && Object.prototype.hasOwnProperty.call(node, LOGICAL_PARENT)) {
    const layerElement = node as LayerElement;
    return layerElement[LOGICAL_PARENT];
  }
  return undefined;
};

export const isLogicalAncestor = (ancestorNode: Node, node: Node) => {
  let parentNode: Node | null = node;
  while (parentNode) {
    if (parentNode === ancestorNode) {
      return true;
    }
    const logicalParent = getLogicalParent(parentNode);
    if (logicalParent) {
      parentNode = logicalParent;
    } else {
      parentNode = parentNode.parentNode as Node;
    }
  }
  return false;
};
